import { z } from 'zod';
import { AUTOMATIC_SUPPORTED_UNITS_SCHEMA } from '@schuettflix/interfaces';
import { PriceSchema, PriceSchemaRules } from '@/shared/schemas/PriceSchema.ts';
import { VehicleClassSchema } from '@/shared/models/ContextDataModel/interfaces/entities/vehicle-class.ts';
import { LocationConfigurationSchema } from '@/modules/location/domain/LocationConfigurationSchema.ts';
import { LocationTypeSchema } from '@/modules/location/domain/LocationSchema.ts';

export type IsSalesTransportIncludedUnionParams = {
    errorMessages?: {
        required?: string;
    };
    formRules?: {
        priceRules?: PriceSchemaRules;
    };
};

export function getIsSalesTransportIncludedUnion(params?: IsSalesTransportIncludedUnionParams) {
    const { errorMessages = {}, formRules = {} } = params ?? {};
    const { required } = errorMessages;
    const { priceRules = {} } = formRules ?? {};

    return z.discriminatedUnion('isSalesTransportIncluded', [
        z.object({
            isSalesTransportIncluded: z.literal(false),
            vehicleClass: z.object(VehicleClassSchema.shape, { message: required }),
            salesTransportQuantity: z.number({ required_error: required }).nonnegative(required),
            salesTransportUnit: z.enum(AUTOMATIC_SUPPORTED_UNITS_SCHEMA.options, { required_error: required }),
            salesTransportPrice: PriceSchema({
                ...priceRules,
                errorMessages: { required, nonNegative: required, multipleOf: required },
            }),
            salesTransportTaxClassId: z.string({ message: required }),
            showZeroSalesTransportPrice: z.boolean(),
            loadingLocation: z.object(LocationConfigurationSchema.shape, { message: required }),
            unloadingLocation: z.object(LocationConfigurationSchema.shape, { message: required }),
            weighingLocation: z.enum(LocationTypeSchema.options, { message: required }).nullable(),
        }),
        z.object({
            isSalesTransportIncluded: z.literal(true),
        }),
    ]);
}
